module.exports = __webpack_public_path__ + "static/Jolly_Abraham.c64b54cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Jolly_Abraham.jpg
// module id = 918
// module chunks = 146520050992020